import { fromJS } from 'immutable'
import {
  TIMSHEET_STATUS_SET_OPTIONS,
} from './../../constants'

const init = fromJS({
  statusOptions: {
    filterButtonStatus: 1,
    sortOrderStatus: true,
    sortColumnStatus: 0,
  },
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMSHEET_STATUS_SET_OPTIONS:
      return state
        .set('statusOptions', action.payload)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-set-options-reducer.js